export default function DetailPage() {
    return <>hello!</>;
}
